import { LabelWithMessage } from '@common/LabelWithMessage';
import { Checkbox, Grid, ToastMessage, removeItemInArray, toastMessage } from '@gcl/react-core';
import * as React from 'react';
import {
  IProjectMasterScheduleOptionWithProjectTeamMasterSchedule,
  IProjectTeamMasterScheduleBase,
} from '@masterSchedule/masterSchedule.models';
import { EProjectTeamNameConst } from '@projectTeam/projectTeam.constants';
import { getItemAndRestInArray } from '@common/collection.services';
import { routes } from '@routes/routes.models';
import { useNavigate } from '@routes/routes.hooks';
import { IProjectTeam } from '@projectTeam/projectTeam.models';
import { ETeamFormKeys } from './teamModal.models';
import './AssignT1Team.scss';

export interface IAssignT1TeamProps {
  assignT1Teams: IProjectMasterScheduleOptionWithProjectTeamMasterSchedule[];
  allTeams: IProjectTeam[];
  onChangeAssignT1Teams: (teams: IProjectTeamMasterScheduleBase[]) => void;
}

export const AssignT1Team: React.FC<IAssignT1TeamProps> = ({ assignT1Teams, onChangeAssignT1Teams, allTeams }) => {
  const { navigate } = useNavigate();
  const onChangeRow = (e: any, teams: IProjectTeamMasterScheduleBase[], targetTeam: IProjectTeam) => {
    e.stopPropagation();
    const { foundItem: allUserTeam, restItems: otherTeams } = getItemAndRestInArray(teams, (t) => {
      return t.teamName === EProjectTeamNameConst.ALL_USERS;
    });
    if (targetTeam.teamName === EProjectTeamNameConst.ALL_USERS) {
      // if uncheck all users
      if (allUserTeam?.id) {
        toastMessage(
          <ToastMessage
            message="Cannot unselect all users team without selecting other teams"
            toastOptions={{ type: 'error', closeOnClick: true, autoClose: false }}
          />,
        );
        return;
      }
      // check all users
      if (!allUserTeam?.id) {
        onChangeAssignT1Teams([
          allUserTeam ?? {
            teamName: targetTeam.teamName,
            id: 0,
            projectMasterScheduleId: teams[0].projectMasterScheduleId,
            projectTeamId: targetTeam.id ?? 0,
            projectId: targetTeam.projectId,
            rowVersion: '',
          },
        ]);
        return;
      }
      return;
    }

    let request: IProjectTeamMasterScheduleBase[] = [...otherTeams];
    const foundIndex = otherTeams.findIndex((s) => s.projectTeamId === targetTeam.id);
    if (foundIndex >= 0) {
      // uncheck
      request = removeItemInArray(request, foundIndex);
    } else if (targetTeam.id) {
      // check
      request.push({
        teamName: targetTeam.teamName,
        id: 0,
        projectMasterScheduleId: teams[0].projectMasterScheduleId,
        projectTeamId: targetTeam.id,
        projectId: targetTeam.projectId,
        rowVersion: '',
      });
    }

    if (request.length === 0) {
      toastMessage(
        <ToastMessage
          message="At least one team should be selected"
          toastOptions={{ type: 'error', closeOnClick: true, autoClose: false }}
        />,
      );
      return;
    }
    onChangeAssignT1Teams(request);
  };

  return (
    <Grid container item xs={12}>
      <LabelWithMessage labelFor={ETeamFormKeys.ASSIGN_T1} text="Assign T1s" />
      <Grid container item flexDirection="row" flex="1 1 100%" columnGap={2}>
        <Grid item flex="1 1 auto" />
        {allTeams.map((team) => {
          return (
            <Grid item key={`header-team-${team.id}`}>
              {team.teamName}
            </Grid>
          );
        })}
      </Grid>
      {assignT1Teams?.map((masterScheduleOption) => {
        return (
          <Grid
            container
            item
            key={`row-${masterScheduleOption.id}`}
            flexDirection="row"
            flex="1 1 100%"
            className="gcl-gems-team-form-assign-t1-container"
            columnGap={2}
          >
            <Grid item flex="1 1 auto">
              <span
                className="gcl-fl-sm"
                onClick={() => {
                  navigate(routes.t1.view.path, { id: masterScheduleOption.id });
                }}
              >
                {masterScheduleOption.refNo}
              </span>
            </Grid>
            {allTeams.map((team) => {
              return (
                <Grid item key={`row-option-team-${team.id}`}>
                  <Checkbox
                    id={`row-${masterScheduleOption.id}-checkbox-${team.id}`}
                    onChange={() => {}}
                    onClick={(e) => {
                      onChangeRow(e, masterScheduleOption.projectTeamMasterSchedules, team);
                    }}
                    checked={!!masterScheduleOption.projectTeamMasterSchedules.find((s) => s.projectTeamId === team.id)}
                  />
                </Grid>
              );
            })}
          </Grid>
        );
      })}
    </Grid>
  );
};
